{
  "abox": {
    "counts": "{{statements}} · {{individuals}}",
    "download": "Download N-Quads",
    "overview": "Overview",
    "provenance": "Provenance",
    "sourceUnavailable": "This document reference is unavailable.",
    "technical": "Technical details",
    "title": "Statements"
  },
  "counts": {
    "individuals_one": "{{count}} individual",
    "individuals_other": "{{count}} individuals",
    "newerProposals_one": "{{count}} newer proposal",
    "newerProposals_other": "{{count}} newer proposals",
    "statements_one": "{{count}} statement",
    "statements_other": "{{count}} statements"
  },
  "curation": {
    "accept": "Accept into the knowledge data",
    "by": "by {{name}}, {{time}}",
    "by_you": "by you, {{time}}",
    "comment": "Comment (needed to reject)",
    "kinds": {
      "accept": "Accepted",
      "carried_forward": "Carried forward",
      "reject": "Rejected",
      "supersede": "Superseded",
      "withdraw": "Withdrawn"
    },
    "none": "No decision yet: this result is a proposal.",
    "notCurator": "A curator of this result's label list decides on it.",
    "reject": "Reject",
    "title": "Curation"
  },
  "dataset": {
    "copyDigest": "Copy the package digest",
    "copyIri": "Copy the dataset's IRI",
    "earlierRevision": "Earlier revision; not selected by default.",
    "fields": {
      "description": "Description",
      "licence": "Licence",
      "licenceHelp": "An SPDX identifier, such as CC-BY-4.0, or the address of a licence.",
      "title": "Title"
    },
    "metadata": "Metadata",
    "noAccepted": "No accepted results yet.",
    "noVersions": "No version yet.",
    "oneRevision": "Selecting a revision replaces the selected revision of that lineage.",
    "problems": {
      "multipleRevisions": "{{members}}: revisions of one lineage ({{lineage}}); keep one. Its accepted version is {{head}}.",
      "multipleRevisionsNoHead": "{{members}}: revisions of one lineage ({{lineage}}); keep one. It has no accepted version.",
      "notAccepted": "{{extraction}}: {{state}}, not accepted.",
      "notFound": "{{extraction}}: not a result of this project."
    },
    "replaces": "Replaces earlier result: {{sources}}",
    "versionFacts_one": "{{count}} result, by {{name}}, {{time}}",
    "versionFacts_other": "{{count}} results, by {{name}}, {{time}}",
    "versions": "Versions",
    "versionsImmutable": "A version never changes: it downloads as the same bytes every time."
  },
  "export": {
    "formats": {"nquads": "N-Quads", "trig": "TriG"},
    "quads_one": "{{count}} quad",
    "quads_other": "{{count}} quads"
  },
  "extraction": {
    "copyIri": "Copy the result's IRI",
    "generatedWhen": "{{generation}}, {{time}}",
    "instanceHint": "Each statement shows the passage of the source that says it. Individuals keep their IRI when a reviewer edits the result.",
    "instanceStatements_one": "{{count}} statement",
    "instanceStatements_other": "{{count}} statements",
    "openThread": "Open in the Run",
    "saysTriples": "What it says",
    "showTriples": "Technical details: the triples",
    "statementsFrom": "Statements from <document/>",
    "title": "Extraction result"
  },
  "generation": {
    "agent_turn": "Agent step",
    "carried_forward": "Carried forward",
    "human_review": "Reviewed by a participant"
  },
  "index": {
    "annotations_one": "{{count}} annotation",
    "annotations_other": "{{count}} annotations",
    "statementsResults_one": "{{count}} result",
    "statementsResults_other": "{{count}} results",
    "statements_one": "{{count}} statement",
    "statements_other": "{{count}} statements"
  },
  "lenses": {
    "term": {
      "byState": "{{state}}: {{uses}}",
      "individuals_one": "{{count}} individual",
      "individuals_other": "{{count}} individuals",
      "none": "No statement uses this term yet.",
      "statements_one": "{{count}} statement",
      "statements_other": "{{count}} statements"
    }
  },
  "lineage": {
    "closed": "Closed proposals:",
    "confirm_one": "Merging this proposal will close {{count}} newer proposal. Continue?",
    "confirm_other": "Merging this proposal will close {{count}} newer proposals. Continue?",
    "inbox": "Knowledge data",
    "inboxEntry": "{{statements}} · by {{name}}, {{time}} · {{newer}}",
    "inboxEntry_you": "{{statements}} · by you, {{time}} · {{newer}}",
    "merge": "Merge into the project's knowledge data",
    "newer": "There is a newer proposal (by {{name}}, {{time}})",
    "newer_you": "There is a newer proposal (by you, {{time}})",
    "notCurator": "A curator of the project's knowledge data decides on it.",
    "pending": "Pending proposal (by {{name}}, {{time}})",
    "pending_you": "Pending proposal (by you, {{time}})",
    "skipped": "Already decided; skipped: {{sources}}",
    "workingState": "Working state of {{name}}",
    "workingState_you": "Your working state"
  },
  "openResearchSpace": "Open in ResearchSpace",
  "provenance": {
    "entry": "Run entry {{entry}}",
    "recordedOnly": "Recorded by DMW.",
    "review": "Review by {{name}}",
    "review_you": "Your review",
    "rows": {
      "agent": "Agent",
      "corpusVersion": "Corpus version",
      "curator": "Curator",
      "finished": "Finished",
      "generatedBy": "Produced by",
      "host": "Ran on the PC of",
      "inputDigest": "Input digest",
      "mapping": "Provenance mapping",
      "model": "LLM",
      "prompt": "Prompt",
      "referencesRead": "Versions read",
      "requestedBy": "Requested by",
      "reviewedOutput": "Reviewed output",
      "route": "LLM route",
      "started": "Started",
      "step": "Step",
      "stepKey": "Step key",
      "threadEntry": "Run",
      "workflow": "Process schema"
    },
    "runEntry": "{{run}} · entry {{entry}}",
    "title": "Provenance"
  },
  "release": {
    "button": "New data release…",
    "download": "Download",
    "downloadAlways": "Every data release can also be downloaded as a file (N-Quads or TriG), the same bytes every time.",
    "metadataFirst": "This is the project's first data release: it starts the series of data releases. Give it a title and a licence.",
    "metadataFromLast": "As in the last data release; changes apply from this one on.",
    "metadataInDialog": "Title, licence and description are set in the data release process schema's step “Describe the release”.",
    "modelVersionHint": "The data release is checked against this version as a whole: each result's terms, then the shapes and the consistency of the merged results. A data release that fails is not made.",
    "newestVersion": "{{name}} ({{time}}, newest)",
    "noModelVersion": "This project has no content version yet. A data release is checked against one.",
    "noResearchSpace": "ResearchSpace is not configured on this installation.",
    "none": "No data release yet.",
    "number": "Data release {{number}}",
    "numberWithTitle": "Data release {{number}} · {{title}}",
    "olderVersion": "{{name}} ({{time}})",
    "projectOff": "This project does not publish to ResearchSpace. A project administrator can switch it on in the project's settings.",
    "results": "Accepted results",
    "step": {
      "members_one": "{{count}} result",
      "members_other": "{{count}} results",
      "missingRequest": "This step builds on the release request, which the step before it has not given yet.",
      "sendWhat_one": "Send: {{count}} result",
      "sendWhat_other": "Send: {{count}} results",
      "staysInDmw": "Stays in DMW, downloadable as a file",
      "toResearchSpace": "Also published to ResearchSpace"
    },
    "toResearchSpace": "Publish to ResearchSpace",
    "versions": "Versions"
  },
  "releaseChecks": {
    "against": "Every member was checked against the data model at the content version chosen for the data release, data model snapshot",
    "attributionPartial": "The engine listed only some of the shapes findings, so members are named only from the listed ones. A member none of them involves is \"not determined\", not a pass.",
    "downloadUnchecked": "Unchecked: this version was made before release checks. The package is unchanged, but it was never checked as a whole.",
    "engine": "Checked by {{engine}}.",
    "hide": "Hide the release checks",
    "members": "Each member: the data model's terms, and the shapes violations it is involved in",
    "merged": "The merged data release: consistency",
    "mergedShapes": "The merged data release: shapes",
    "noInstanceData": "An annotation result: it states nothing of the data model that shapes or rules could check.",
    "noShapes": "The data model at this content version has no shapes, so only its terms were checked.",
    "notDetermined": "Shapes outcome not determined: no listed finding involves it, but some findings are not listed.",
    "older": "Made against an older content version, {{version}}; checked again against this one, not upgraded.",
    "outcomes": "Terms: {{terms}} · Shapes: {{shapes}}",
    "shortened": "This report keeps to its size limit: some long texts are shortened, and some findings or reasons are not listed. Every status and count is complete.",
    "show": "Release checks: {{status}}, against data model snapshot {{version}}. Show the report",
    "statementProblem": "Statement {{number}}: {{reason}}",
    "status": {
      "cannot_run": "Could not run",
      "fail": "Fail",
      "no_instance_data": "Nothing to check",
      "not_determined": "Not determined",
      "pass": "Pass"
    },
    "unchecked": "Not checked as a whole: made before release checks. It stays valid and downloads as before, but cannot be published to ResearchSpace. Make a data release of the same results again to check them.",
    "uncheckedFormat": "{{format}} (unchecked)",
    "unlisted": "Reasons not listed: the report lists them for the first failing members only."
  },
  "researchSpace": {
    "administration": {
      "connected": "Connected",
      "connection": "Connection",
      "hint": "This installation's one ResearchSpace. Its connection is set in the server's configuration ([data.researchspace]); each project switches publishing on in its rules.",
      "running": "State",
      "title": "ResearchSpace"
    },
    "label": "ResearchSpace",
    "notPublished": "Not published",
    "publish": "Publish to ResearchSpace",
    "publishing": "Publishing…",
    "replaced": "Replaced",
    "runtime": {
      "running": "ResearchSpace is running",
      "stopped": "ResearchSpace is stopped",
      "unreachable": "ResearchSpace does not answer"
    },
    "states": {
      "applying": "Reloading",
      "configuring": "Preparing pages",
      "exporting": "Being published",
      "failed": "Failed",
      "published": "In ResearchSpace",
      "requested": "Requested"
    }
  },
  "review": {
    "noResult": "This step names no result to decide.",
    "open": "Open its review",
    "record": "Record the decision in this step"
  },
  "states": {
    "accepted": "Accepted",
    "proposed": "Proposed",
    "rejected": "Rejected",
    "superseded": "Superseded",
    "withdrawn": "Withdrawn"
  }
}
